import { render, staticRenderFns } from "./Domov.vue?vue&type=template&id=3160f82c&scoped=true"
import script from "./Domov.vue?vue&type=script&lang=js"
export * from "./Domov.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3160f82c",
  null
  
)

export default component.exports